import { render, staticRenderFns } from "./Footer_front.vue?vue&type=template&id=5a37a010&"
import script from "./Footer_front.vue?vue&type=script&lang=js&"
export * from "./Footer_front.vue?vue&type=script&lang=js&"
import style0 from "./Footer_front.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports